var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 110.55 110.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #ffcf04;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #003893;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1400",
    "data-name": "Trazado 1400",
    className: "cls-2",
    d: "M94.1,10.67c0-1.07.87-1.94,1.94-1.94h0s3.88,0,3.88,0c1.07-.02,1.96.82,1.98,1.9.02,1.07-.82,1.96-1.9,1.98-.03,0-.06,0-.09,0h-3.88c-1.07,0-1.94-.87-1.94-1.94h0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1401",
    "data-name": "Trazado 1401",
    className: "cls-2",
    d: "M80.52,12.6h3.88c1.07.02,1.96-.82,1.98-1.9.02-1.07-.82-1.96-1.9-1.98-.03,0-.06,0-.09,0h-3.88c-1.07.02-1.92.91-1.9,1.98.02,1.04.86,1.87,1.9,1.9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1402",
    "data-name": "Trazado 1402",
    className: "cls-2",
    d: "M65,12.6h3.88c1.07-.02,1.92-.91,1.9-1.98-.02-1.04-.86-1.87-1.9-1.9h-3.88c-1.07.02-1.92.91-1.9,1.98.02,1.04.86,1.87,1.9,1.9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1403",
    "data-name": "Trazado 1403",
    className: "cls-2",
    d: "M49.48,12.6h3.88c1.07-.02,1.92-.91,1.9-1.98-.02-1.04-.86-1.87-1.9-1.9h-3.88c-1.07.02-1.92.91-1.9,1.98.02,1.04.86,1.87,1.9,1.9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1404",
    "data-name": "Trazado 1404",
    className: "cls-2",
    d: "M49.48,24.24h3.88c1.07-.02,1.92-.91,1.9-1.98-.02-1.04-.86-1.87-1.9-1.9h-3.88c-1.07.02-1.92.91-1.9,1.98.02,1.04.86,1.87,1.9,1.9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1405",
    "data-name": "Trazado 1405",
    className: "cls-2",
    d: "M99.92,20.36h-3.88c-1.07-.02-1.96.82-1.98,1.9s.82,1.96,1.9,1.98c.03,0,.06,0,.09,0h3.88c1.07.02,1.96-.82,1.98-1.9s-.82-1.96-1.9-1.98c-.03,0-.06,0-.09,0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1406",
    "data-name": "Trazado 1406",
    className: "cls-1",
    d: "M65,24.24h19.4c1.07-.02,1.92-.91,1.9-1.98-.02-1.04-.86-1.87-1.9-1.9h-19.4c-1.07.02-1.92.91-1.9,1.98.02,1.04.86,1.87,1.9,1.9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1407",
    "data-name": "Trazado 1407",
    className: "cls-1",
    d: "M98.52,75.83l-9.49-7.27c-4.08-4.06-10.67-4.06-14.75,0l-5.94,5.79c-14.55-6.08-26.11-17.65-32.18-32.21l5.78-5.92c1.96-1.95,3.06-4.61,3.05-7.37.03-2.69-1.01-5.27-2.89-7.19l-7.6-9.87c-4.04-4.04-10.58-4.08-14.66-.09l-4.56,3.98c-4.29,4.31-6.67,10.16-6.62,16.25,0,30.05,39.86,69.91,69.92,69.91,6.13.05,12.02-2.37,16.34-6.71l3.79-4.36c1.97-1.95,3.07-4.61,3.06-7.38,0-2.85-1.18-5.58-3.25-7.55M95.88,88.12l-3.8,4.36c-3.59,3.55-8.45,5.53-13.5,5.47-27.78,0-66.05-38.27-66.05-66.04-.06-5.01,1.88-9.84,5.38-13.42l4.56-3.97c1.25-1.25,2.94-1.95,4.71-1.94,1.64-.02,3.22.61,4.39,1.75l7.6,9.87c2.56,2.57,2.55,6.72-.01,9.28,0,0,0,0,0,0l-6.68,6.85c-.54.55-.7,1.37-.41,2.08,6.5,16.48,19.55,29.52,36.04,35.99.7.28,1.51.12,2.04-.42l6.86-6.68s0-.01.02-.02c2.63-2.57,6.84-2.52,9.41.11.02.02.04.04.05.06l9.48,7.27h0c2.57,2.59,2.55,6.77-.04,9.33-.01.01-.03.03-.04.04"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.13da07f9f7002959eb661d01c132dd2d.svg";
export { ForwardRef as ReactComponent };